import { render } from "./GuiClientStatusSelect.vue?vue&type=template&id=724cf136"
import script from "./GuiClientStatusSelect.vue?vue&type=script&lang=js"
export * from "./GuiClientStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__